module.exports = __webpack_public_path__ + "static/media/ic_blog.7efa9a45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_blog.svg
// module id = 299
// module chunks = 0